// extracted by mini-css-extract-plugin
module.exports = {"button_w_icon":"index-module__button_w_icon___YLFaU","txt":"index-module__txt___e90hf"};